(function () {
  // ---------- TABS ----------
  function initTabs(root) {
    var tabTitles = root.querySelectorAll('.single-product-desc-title');
    var tabContents = root.querySelectorAll('.single-product-desc-text');

    if (!tabTitles.length || !tabContents.length) return;

    tabTitles.forEach(function (title) {
      title.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');

        tabTitles.forEach(function (t) {
          t.classList.remove('is-active');
        });
        tabContents.forEach(function (c) {
          c.classList.remove('is-active');
        });

        this.classList.add('is-active');

        var activeContent = root.querySelector(
          '.single-product-desc-text[data-tab-content="' + target + '"]'
        );
        if (activeContent) {
          activeContent.classList.add('is-active');
        }
      });
    });
  }

  // ---------- GALLERY (thumbs -> main image) ----------
  function initGallery(root) {
    var thumbs = root.querySelectorAll('.single-slider-thumb img');
    var main = root.querySelector('.single-slider-mainImage img');

    if (!thumbs.length || !main) return;

    function setActive(index) {
      if (index < 0 || index >= thumbs.length) return;

      thumbs.forEach(function (img, i) {
        var thumbItem = img.closest('.single-slider-thumb');
        if (thumbItem) {
          thumbItem.classList.toggle('is-active', i === index);
        }
      });

      var t = thumbs[index];

      // копируем src / srcset / alt из превью в main
      main.src = t.currentSrc || t.src;
      if (t.srcset) {
        main.srcset = t.srcset;
      } else {
        main.removeAttribute('srcset');
      }
      main.alt = t.alt || '';
    }

    thumbs.forEach(function (img, index) {
      img.addEventListener('click', function () {
        setActive(index);
      });
    });

    // стартовое состояние
    setActive(0);
  }

  // ---------- INIT FOR ONE PRODUCT BLOCK ----------
  function initSingleProduct(container) {
    if (!container) return;

    // контейнер всей секции (правый+левый)
    var page = container.closest('.single-product') || document;

    initTabs(page);
    initGallery(page);
  }

  // ---------- INIT ALL ON PAGE ----------
  function initAll() {
    var galleries = document.querySelectorAll('.single-product-left');
    if (!galleries.length) return;

    galleries.forEach(function (g) {
      initSingleProduct(g);
    });
  }

  // обычная страница
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // чтобы работало в Theme Editor при перезагрузке секции
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var gallery = section.querySelector('.single-product-left');
    if (gallery) {
      initSingleProduct(gallery);
    }
  });
})();
